import { adminAiConversationQueryKeys as e } from "./adminAiConversationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminAiApi as n } from "@maat/api-ai";
//#region src/ai/admin/useAdminAiConversationQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getConversation(r),
	enabled: !!r
});
//#endregion
export { r as useAdminAiConversationQuery };
